<template>
    <div class="header-line-flex">
        <p>{{ title }}</p>
        <div class="round-btn" @click="editRawData()"><i class="far fa-edit" /></div>
    </div>
</template>

<script>
export default {
    props: ["title"],
    methods: {
        editRawData() {
            this.$emit("edit-raw-data");
        }
    }
};
</script>

<style scoped>
.header-line-flex{
    background-color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    color: #616161;
    line-height: 20px;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 40px;
    padding-right: 20px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1) !important;
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header-line-flex p{
    margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/PageHeader.vue